import { AddImageComponent } from '@/app/atoms/add-image/add-image.component';
import { LdgImgComponent } from '@/app/atoms/ldg-img/ldg-img.component';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { S3BucketEnum } from '@/app/common/general-types/media-assets.dto';
import { BbSegmentedOption } from '@/app/pages/create-brief-select/ui/bb-segmented/bb-segmented';
import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { ImageService } from '@/app/services/image/image.service';
import { ProductService, UgcProductResponseDto } from '@/app/services/product/product.service';
import { Component, inject, OnInit, signal } from '@angular/core';
import { take } from 'rxjs';

@Component({
  selector: 'sbs-product-select',
  imports: [AddImageComponent, LdgImgComponent],
  templateUrl: './product-select.html',
  styleUrl: './product-select.scss',
})
export class ProductSelect implements OnInit {

  readonly S3Bucket = S3BucketEnum;

  readonly modeOptions: BbSegmentedOption[] = [
    { value: 'existing', label: 'Choose existing' },
    { value: 'new', label: 'Add new product' },
  ];

  readonly mode = signal<'existing' | 'new'>('existing');
  readonly products = signal<UgcProductResponseDto[]>([]);
  readonly loading = signal<boolean>(true);

  displayAdditionalProductImages = signal<string[]>([]);

  /** Services */
  private readonly productService = inject(ProductService);
  private readonly currentUserService = inject(CurrentUserService);
  public imageService = inject(ImageService);
  public createScreeningService = inject(CreateScreeningService);
  /** Services - END */

  ngOnInit(): void {
    const persisted = this.createScreeningService.additionalProductImages();
    if (persisted.length) {
      this.displayAdditionalProductImages.set([...persisted]);
    }

    const brandId = this.currentUserService.focussedBrand?.id;
    if (!brandId) {
      this.loading.set(false);
      return;
    }
    this.productService
      .getbusinessProducts(brandId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.products.set((response as UgcProductResponseDto[]) ?? []);
          this.loading.set(false);
        },
        error: () => this.loading.set(false),
      });
  }

  selectProduct(product: UgcProductResponseDto): void {
    this.createScreeningService.selectedProduct.set(product);
  }

  clearSelection(): void {
    this.createScreeningService.selectedProduct.set(undefined);
    this.createScreeningService.additionalProductImages.set([]);
    this.displayAdditionalProductImages.set([]);
  }

  onImageUploaded(event: { file: string, fileKey: string, fullUrl: string }): void {
    this.createScreeningService.additionalProductImages.set([...this.createScreeningService.additionalProductImages(), event.fullUrl]);
    this.displayAdditionalProductImages.set([...this.displayAdditionalProductImages(), event.fileKey]);
  }

  onImageDelete(image: string): void {
    const index = this.displayAdditionalProductImages().indexOf(image);
    if (index === -1) {
      return;
    }

    this.displayAdditionalProductImages.update((imgs) => imgs.filter((i) => i !== image));
    this.createScreeningService.additionalProductImages.update((urls) =>
      urls.filter((_, i) => i !== index),
    );
  }

}
